import { displayISODateTime } from 'shared/helpers/common';

const tableHeaderStyle = ' text-gray-500 pb-3 font-normal md:pl-8';
const tableBodyStyle = 'py-3 border-b md:pl-8';

export default function CruiseItineraryTable({
  className = '',
  itinerary = [],
}) {

const sortedItinerary = itinerary
  .slice()
  .sort((a, b) => {
    if (a.dayNumber !== b.dayNumber) {
      return a.dayNumber - b.dayNumber;
    }
    const aTime = a.departureDateTime?.timestamp ?? 0;
    const bTime = b.departureDateTime?.timestamp ?? 0;
    return aTime - bTime;
  });

  return (
    <table className={`${className} table-fixed w-full text-left break-words`}>
      <thead>
        <tr className="text-gray-500 border-b">
          <th className={`w-[10%] sm:w-[25%] ${tableHeaderStyle}`}>
            <span className="inline sm:hidden">Day</span>
            <span className="hidden sm:inline">Itinerary day</span>
          </th>
          <th className={`w-[30%] sm:w-[25%] ${tableHeaderStyle}`}>Port</th>
          <th className={`w-[30%] sm:w-[25%] ${tableHeaderStyle}`}>Arriving</th>
          <th className={`w-[30%] sm:w-[25%] ${tableHeaderStyle}`}>Departing</th>
        </tr>
      </thead>
      <tbody className="text-xs sm:text-base">
        {sortedItinerary.map(({ dayNumber, port, arrivalDateTime, departureDateTime }) => (
          <tr key={`${dayNumber}-${port}`}>
            <td className={tableBodyStyle}>{dayNumber}</td>
            <td className={tableBodyStyle}>{port}</td>
            <td className={tableBodyStyle}>{displayISODateTime(arrivalDateTime, true, true)}</td>
            <td className={tableBodyStyle}>{displayISODateTime(departureDateTime, true, true)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
